import Landing from './Landing/Landing';
import Details from '@/views/Details';
import EmiPlans from '@/views/EmiPlans';
import SelfieKYC from '@/views/SelfieKYC';
import EMandateSuccess from '@/views/EMandateSuccess';
import EmployerDetails from '@/views/Employer-details';
import DigiLockerSuccess from '@/views/DigiLockerSuccess';
import Payments from '@/views/Payments';

export const screensMap = {
  LANDING: 'LANDING',
  DETAILS: 'DETAILS',
  SELFIE_KYC: 'SELFIE_KYC',
  EMPLOYER_DETAILS: 'EMPLOYER_DETAILS',
  EMI_PLANS: 'EMI_PLANS',
  DIGILOCKER_SUCCESS: 'DIGILOCKER_SUCCESS',
  E_MANDATE_SUCCESS: 'E_MANDATE_SUCCESS',
  PAYMENTS: 'PAYMENTS',
};

export const viewMap = {
  LANDING: Landing,
  DETAILS: Details,
  SELFIE_KYC: SelfieKYC,
  EMPLOYER_DETAILS: EmployerDetails,
  EMI_PLANS: EmiPlans,
  DIGILOCKER_SUCCESS: DigiLockerSuccess,
  E_MANDATE_SUCCESS: EMandateSuccess,
  PAYMENTS: Payments,
};
